import {
  getAccessToken,
  getALMConfig,
} from "./global";

export interface ALMObject {
    id: string;
    title: string;
    description?: string;
    loType: string;
    imageUrl?: string;
    bannerUrl?: string;
    rating?: string;
    ratingsCount?: number;
    tags?: string[];
    duration?: number;
    progressPercent?: number;
    state?: string;
    course?: string;
    instance?: string; 
}

export interface ALMApiResponse {
    data: ALMObject[];
    links: { self?: string; next?: string; prev?: string };
}

export async function fetchLearningObjects(apiUrl: string): Promise<ALMApiResponse> {
    console.log("calling api");
    const res = await fetch(apiUrl, {
        method: "GET",
        headers: {
            "Authorization": `oauth ${getAccessToken()}`,
            "Accept": "application/vnd.api+json"
        }
    });
    debugger;
    if (!res.ok) {
        throw new Error(`Api request failed : ${res.status} ${res.statusText}`);
    }
    const json = await res.json();
    // Build included lookup map
    const includedMap: Record<string, any> = {};
    (json.included || []).forEach((inc: any) => {
        includedMap[inc.id] = inc;
    });
    // Merge data and included
    const data = (json.data || []).map((item: any) => {
        const loId = item.relationships?.learningObject?.data?.id;
        const metaObj = includedMap[loId]?.attributes || {};
        const meta = metaObj.localizedMetadata?.[0] || {};
        return {
            id: item.id,
            title: meta.name || "Untitled",
            description: meta.description || meta.overview || "",
            loType: metaObj.loType || "",
            imageUrl: metaObj.imageUrl,
            bannerUrl: metaObj.bannerUrl,
            rating: metaObj.rating?.averageRating ?? 0,
            ratingsCount: metaObj.rating?.ratingsCount ?? 0,
            tags: metaObj.tags || [],
            duration: metaObj.duration || 0,
            progressPercent: item.attributes.progressPercent ?? 0,
            state: item.attributes.state || "",
            course: item.relationships.learningObject.data.id || item.id,
            instance: includedMap[loId]?.relationships.instances.data[0].id
        } as ALMObject;
    });
    return {
        data,
        links: json.links || {}
    };
}